<template>
  <form @submit.prevent="submit" v-promise-btn="{ action: 'submit' }">
    <div class="card container">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label for="origen" class="label">Origen</label>
            <multiselect-item
              id="origen"
              v-model="origen"
              track-by="id_ubic"
              placeholder="Seleccione una cuenta"
              :custom-label="label"
              :options="origenOptions"
            ></multiselect-item>
          </div>
        </div>
      </div>
      <div class="row" v-if="origen">
        <div class="col">
          <div class="form-group">
            <label for="dineroDisponible" class="label">
              Dinero disponible:
            </label>
            <input
              id="dineroDisponible"
              disabled
              type="text"
              :value="formatMoney(origen.Monto)"
              class="form-control"
            />
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="dineroRestante" class="label"> Dinero restante: </label>
            <input
              id="dineroRestante"
              type="text"
              disabled
              :value="formatMoney(dineroRestante)"
              class="form-control"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card container">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label for="montoATransferir" class="label">Monto</label>
            <vue-numeric
              id="montoATransferir"
              currency="$"
              thousand-separator="."
              decimal-separator=","
              :precision="2"
              v-model="montoATransferir"
              class="form-control text-center"
              v-select-on-focus
            ></vue-numeric>
          </div>
        </div>
      </div>
    </div>

    <div class="card container">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label for="origen" class="label">Destino</label>
            <multiselect-item
              id="destino"
              v-model="destino"
              track-by="id_ubicacion_dinero"
              placeholder="Seleccione una cuenta"
              :custom-label="(ubic) => `${ubic.ubicacion_dinero}`"
              :options="destinoOptions"
            ></multiselect-item>
          </div>
        </div>
      </div>
    </div>
    <div class="card container">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label for="anotaciones" class="label">Anotaciones</label>
            <input
              id="anotaciones"
              type="text"
              class="form-control"
              v-model="anotaciones"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between">
      <button class="btn btn-danger" type="button" @click="hideModal">
        Cancelar
      </button>
      <button class="btn btn-primary" type="submit">Confirmar</button>
    </div>
  </form>
</template>

<script>
import stringToFloatMoneyParser from "@/lib/utils/stringToFloatMoneyParser";

import { formatM } from "@/lib/utils/accountingJsFns";
import vueNumeric from "../../lib/utils/vue-numeric.vue";

export default {
  name: "MakeEfectivoTransaction",
  components: { vueNumeric },
  mixins: [stringToFloatMoneyParser],
  beforeMount() {
    this.init();
  },
  computed: {
    origenOptions() {
      return this.$store.getters["cuentas/getCuentasEfectivo"];
    },
    destinoOptions() {
      try {
        return this.$store.getters["ubicacionDinero/getUbicaciones"].filter(
          (ubicacion) => ubicacion.id_ubicacion_dinero !== this.origen.id_ubic,
        );
      } catch (e) {
        return [];
      }
    },
    dineroRestante() {
      return (
        this.parsePotentiallyGroupedFloat(this.origen.Monto) -
        this.parsePotentiallyGroupedFloat(this.montoATransferir.toString())
      );
    },
  },
  data: () => ({
    origen: null,
    montoATransferir: 0,
    destino: null,
    anotaciones: "",
  }),
  methods: {
    formatMoney(value) {
      return formatM(value);
    },
    async submit() {
      let fd = new FormData();

      fd.append("origen_id_ubicacion_dinero", this.origen.id_ubic);
      fd.append(
        "destino_id_ubicacion_dinero",
        this.destino.id_ubicacion_dinero,
      );
      fd.append("moneda", this.origen.tipo_dinero);
      fd.append("monto", this.montoATransferir);
      fd.append("anotaciones", this.anotaciones);

      let resp = await this.$store.dispatch("cuentas/makeTransaction", fd);

      this.hideModal();

      this.$nextTick(() => {
        this.$bvToast.toast(resp, {
          variant: "success",
        });
      });
      return true;
    },
    label(cuenta) {
      return `${cuenta.ubicacion} - ${cuenta.tipo_dinero}`;
    },
    hideModal() {
      this.$bvModal.hide("makeTransactionModal");
    },
    async init() {
      this.$store.dispatch("ubicacionDinero/getUbicaciones");
    },
    reset() {
      this.origen = null;
      this.montoATransferir = 0;
      this.destino = null;
      this.anotaciones = "";
    },
  },
};
</script>

<style scoped></style>
